<template>
  <div>
    <div class="row">
      <div class="mb-3">
        <button class="btn btn-primary float-end btn-sm" @click="showBarang">{{ $t('barang_txt') }}</button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 grid-margin stretch-card">
        <div class="card">
          <div class="card-header">
            <h6 class="card-title">{{ $t("price") }}</h6>
          </div>
          <div class="card-body">
            <div class="mb-3">
              <label class="form-label">{{ $t("valuta") }}</label>
              <v-select :options="fetchValuta" @input="checkKurs" v-model="valuta" label="label"
                return-object></v-select>

              <div v-if="this.valuta == null || this.valuta?.code == ''">
                <div class="alert alert-danger" style="padding:5px;" role="alert">
                  <i data-feather="alert-circle"></i>
                  Valuta Kosong
                </div>
              </div>

              <div v-if="errors.kodeValuta">
                <div v-for="error in errors.kodeValuta" :key="error" class="alert alert-primary" role="alert">
                  <i data-feather="alert-circle"></i>
                  {{ error }}
                </div>
              </div>
            </div>

            <div class="mb-3">
              <label class="form-label">NDPBM</label>
              <!-- <input type="number" class="form-control" readonly :id="this.$dynamicId()" v-model.number="forms.ndpbm"
                maxlength="255" /> -->
              <vue-number class="form-control" v-model="forms.ndpbm" v-bind="formatCurrency" ref="kurs"></vue-number>

              <div v-if="errors.ndpbm">
                <div v-for="error in errors.ndpbm" :key="error" class="alert alert-primary" role="alert">
                  <i data-feather="alert-circle"></i>
                  {{ error }}
                </div>
              </div>
            </div>

            <div class="mb-3">
              <label class="form-label">{{ $t("jenis_transaksi") }}</label>

              <v-select :options="fetchJenis" v-model="jenisTransaksi" label="label" return-object></v-select>

              <div v-if="this.jenisTransaksi == null || this.jenisTransaksi?.code == ''">
                <div class="alert alert-danger" style="padding:5px;" role="alert">
                  <i data-feather="alert-circle"></i>
                  Jenis Transaksi Kosong
                </div>
              </div>

              <div v-if="errors.kodeIncoterm">
                <div v-for="error in errors.kodeIncoterm" :key="error" class="alert alert-primary" role="alert">
                  <i data-feather="alert-circle"></i>
                  {{ error }}
                </div>
              </div>
            </div>

            <div class="mb-3">
              <label class="form-label">{{ $t('harga_barang') }}</label>
              <div class="row">
                <div class="col-sm-6">
                  <v-select :options="fetchHargaBarang" v-model="hargaBarang" @input="checkImput" label="label"
                    return-object></v-select>

                  <div v-if="this.hargaBarang == null || this.hargaBarang?.code == ''">
                    <div class="alert alert-danger" style="padding:5px;" role="alert">
                      <i data-feather="alert-circle"></i>
                      Kode Harga Kosong
                    </div>
                  </div>

                  <div v-if="errors.kodeJenisNilai">
                    <div v-for="error in errors.kodeJenisNilai" :key="error" class="alert alert-primary" role="alert">
                      <i data-feather="alert-circle"></i>
                      {{ error }}
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <!-- <input type="number" class="form-control" :id="this.$dynamicId()" v-model.number="nilaiBarang"
                    maxlength="255" /> -->
                  <!-- <money class="form-control" v-model="forms.nilaiIncoterm" v-bind="money"></money> -->
                  <vue-number class="form-control" v-model="forms.nilaiIncoterm" v-bind="formatCurrency"></vue-number>


                  <div v-if="forms.nilaiIncoterm < nilaiBarangTotal">
                    <div class="alert alert-warning" role="alert">
                      Nilai incoterm {{ forms.nilaiIncoterm }} lebih kecil dari Total Nilai Barang {{ nilaiBarangTotal
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="mb-3">
              <label class="form-label">{{ $t('nilai_pabean') }}</label>
              <!-- <input type="number" class="form-control" :id="this.$dynamicId()" step=".01" v-model="forms.nilaiIncoterm"
                maxlength="255" /> -->
              <!-- <money class="form-control" readonly :value="cif" v-bind="money"></money> -->
              <vue-number readonly class="form-control" :value="cif" v-bind="formatDecimal"></vue-number>

              <div v-if="errors.cif">
                <div v-for="error in errors.cif" :key="error" class="alert alert-primary" role="alert">
                  <i data-feather="alert-circle"></i>
                  {{ error }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 grid-margin stretch-card">
        <div class="card">
          <div class="card-header">
            <h6 class="card-title">{{ $t("harga_lainnya") }}</h6>
          </div>
          <div class="card-body">

            <div class="mb-3">
              <label class="form-label">{{ $t("biaya_penambah") }}</label>
              <!-- <input type="number" class="form-control" :id="this.$dynamicId()" step=".01" v-model.number="biayaTambahan"
                maxlength="255" /> -->

              <vue-number class="form-control" v-model="forms.biayaTambahan" v-bind="formatDecimal"></vue-number>


              <div v-if="errors.biayaTambahan">
                <div v-for="error in errors.biayaTambahan" :key="error" class="alert alert-primary" role="alert">
                  <i data-feather="alert-circle"></i>
                  {{ error }}
                </div>
              </div>
            </div>
            <div class="mb-3">
              <label class="form-label">{{ $t("biaya_pengurang") }}</label>
              <!-- <input type="number" class="form-control" :id="this.$dynamicId()" step=".01" v-model.number="biayaPengurang"
                maxlength="255" /> -->
              <vue-number class="form-control" v-model="forms.biayaPengurang" v-bind="formatDecimal"></vue-number>


              <div v-if="errors.biayaPengurang">
                <div v-for="error in errors.biayaPengurang" :key="error" class="alert alert-primary" role="alert">
                  <i data-feather="alert-circle"></i>
                  {{ error }}
                </div>
              </div>
            </div>
            <div class="mb-3">
              <label class="form-label">{{ $t('freight') }}</label>
              <!-- <input type="number" class="form-control" :disabled="isFreight" :id="this.$dynamicId()" step=".01" v-model.number="freight"
                maxlength="255" /> -->
              <vue-number class="form-control" v-model="forms.freight" :readonly="isFreight"
                v-bind="formatDecimal"></vue-number>

              <div v-if="errors.freight">
                <div v-for="error in errors.freight" :key="error" class="alert alert-primary" role="alert">
                  <i data-feather="alert-circle"></i>
                  {{ error }}
                </div>
              </div>
            </div>



            <div class="mb-3">
              <label class="form-label">{{ $t('asuransi') }}</label>
              <div class="row">
                <div class="col-sm-6">
                  <v-select :options="fetchAsuransi" v-model="asuransi" label="label" return-object></v-select>

                  <div v-if="errors.kodeAsuransi">
                    <div v-for="error in errors.kodeAsuransi" :key="error" class="alert alert-primary" role="alert">
                      <i data-feather="alert-circle"></i>
                      {{ error }}
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <!-- <input type="number" class="form-control" :id="this.$dynamicId()" step=".01"
                    v-model.number="asuransiVal" maxlength="255" /> -->
                  <vue-number class="form-control" v-model="forms.asuransi" v-bind="formatDecimal"></vue-number>

                  <div v-if="errors.asuransi">
                    <div v-for="error in errors.asuransi" :key="error" class="alert alert-primary" role="alert">
                      <i data-feather="alert-circle"></i>
                      {{ error }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="mb-3">
              <label class="form-label">{{ $t('voluntary_declaration') }}</label>
              <!-- <input type="number" class="form-control" :id="this.$dynamicId()" step=".01" v-model.number="vd"
                maxlength="255" /> -->
              <vue-number class="form-control" v-model="forms.vd" v-bind="formatDecimal"></vue-number>

              <div v-if="forms.vd < vdBarang">
                <div class="alert alert-warning" role="alert">
                  VD {{ forms.vd }} lebih kecil dari Total VD {{ vdBarang }}
                </div>
              </div>

              <div v-if="errors.vd">
                <div v-for="error in errors.vd" :key="error" class="alert alert-primary" role="alert">
                  <i data-feather="alert-circle"></i>
                  {{ error }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 grid-margin stretch-card">
        <div class="card">
          <div class="card-header">
            <h6 class="card-title">{{ $t("weight_txt") }}</h6>
          </div>
          <div class="card-body">

            <div class="mb-3">
              <label class="form-label">{{ $t("berat_kotor") }}</label>
              <!-- <input type="number" class="form-control" :id="this.$dynamicId()" step=".01" v-model.number="netto"
                maxlength="255" /> -->
              <vue-number class="form-control" v-model="forms.bruto" v-bind="formatDecimal"></vue-number>

              <div v-if="errors.bruto">
                <div v-for="error in errors.bruto" :key="error" class="alert alert-primary" role="alert">
                  <i data-feather="alert-circle"></i>
                  {{ error }}
                </div>
              </div>
              <div v-if="forms.bruto < netto">
                <div class="alert alert-warning" role="alert">
                  Berat Kotor {{ forms.bruto }} lebih kecil dari Total Berat Bersih {{ netto }}
                </div>
              </div>
            </div>
            <div class="mb-3">
              <label class="form-label">{{ $t("berat_bersih") }}</label>
              <!-- <input type="number" class="form-control" :id="this.$dynamicId()" step=".01" v-model.number="bruto"
                maxlength="255" /> -->
              <!-- <money class="form-control" disabled :value="netto" v-bind="money"></money> -->
              <vue-number class="form-control" disabled :value="netto" v-bind="formatDecimal"></vue-number>

              <div v-if="errors.netto">
                <div v-for="error in errors.netto" :key="error" class="alert alert-primary" role="alert">
                  <i data-feather="alert-circle"></i>
                  {{ error }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">

        <a class="nav-link" id="entitas-line-tab" data-toggle="tab" href="#entitas" role="tab" aria-controls="disabled"
          aria-selected="false">
          <button class="btn btn-info float-end btn-sm" @click="submitData()" type="button" :disabled="isLoading">

            <div v-show="isLoading">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              Loading...
            </div>
            <div v-show="!isLoading">
              <i class="link-icon mdi mdi-content-save"></i>
              {{ $t("save_change_txt") + " " + $t('transaksi') }}
            </div>
          </button>
        </a>

      </div>
    </div>

    <modalListBarang :propsData="barang"></modalListBarang>

  </div>


</template>

<script>
import { component as VueNumber } from '@coders-tm/vue-number-format'
import modalListBarang from "@/components/exim/ceisa/barang_impor/modal/modalListBarang.vue"

export default {
  name: "CeisaTransaksi",
  components: {
    VueNumber,
    modalListBarang,
  },
  props: {
    propsData: { type: [Object, Array] }
  },
  data() {
    return {
      formatDecimal: {
        "separator": ",",
        "decimal": ".",
        "precision": 2,
        "nullValue": "0",
        "minimumFractionDigits": 2,
        "prefill": false
      },
      formatCurrency: {
        "separator": ",",
        "decimal": ".",
        "precision": 4,
        "nullValue": "0",
        "minimumFractionDigits": 4,
        "prefill": false
      },

      forms: {
        ndpbm: 0,
        nilaiIncoterm: 0,
        biayaTambahan: 0,
        biayaPengurang: 0,
        freight: 0,
        asuransi: 0,
        vd: 0,
        bruto: 0,
      },
      errors: [],

      fetchValuta: [],
      valuta: null,

      fetchJenis: [],
      jenisTransaksi: null,

      fetchHargaBarang: [],
      hargaBarang: null,

      fetchAsuransi: [],
      asuransi: null,

      barang: null,

      isFreight: false,

      isLoading: false,
    };
  },
  methods: {
    showBarang() {
      this.$modal.show('DocumentListBarang');
    },
    checkImput(ev) {
      this.isFreight = false;
      this.forms.freight = 0;
      if (ev) {
        if (ev.code == "CIF") {
          this.isFreight = true;
        }
      }
    },
    submitData() {
      this.isLoading = true;
      this.forms.kodeValuta = this.valuta?.code;
      this.forms.namaValuta = this.valuta?.name;

      this.forms.kodeJenisNilai = this.jenisTransaksi?.code;
      this.forms.namaJenisNilai = this.jenisTransaksi?.name;

      this.forms.kodeIncoterm = this.hargaBarang?.code;
      this.forms.namaIncoterm = this.hargaBarang?.name;

      this.forms.kodeAsuransi = this.asuransi?.code;
      this.forms.namaAsuransi = this.asuransi?.name;

      this.forms.cif = this.cif;
      this.forms.netto = this.netto;

      if(this.forms.vd > 0 ){
        this.forms.flagVd = "Y";
      }else{
        this.forms.flagVd = "T";
      }

      const baseURI = this.$settings.endPointCeisa + "v1/document/store-step-7-transaksi";
      return this.$http
        .post(
          baseURI, this.forms, { timeout: 10000 }
        )
        .then((response) => {
          if (response.data.status === 200) {
            this.loading();
            this.errors = [];
            this.success('Berhasil');
            this.$emit("updateData");
          } else {
            this.loading();
            this.errors = response.data.errors;
            this.resultError(response.data.errors);
          }

        }).catch(error => {
          this.loading();
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }

          if (error.response) {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
              this.resultError(error.response.data.errors);
            } else if (error.response.status === 401) {
              this.logout();
            } else if (error.response.status === 403) {
              this.$router.push("/authorized-error");
            } else if (error.response.status === 500) {
              this.$router.push('/server-error');
            } else {
              this.$router.push('/page-not-found');
            }
          }

        });
    },
    checkKurs(ev) {
      if (ev) {
        const baseURI = this.$settings.endPointCeisa + "v1/system-code/index?limit=1&page=1&type=kurs&code=" + ev.code;
        return this.$http
          .get(
            baseURI, { timeout: 100000 }
          )
          .then((response) => {

            var models = response.data.datas.data;

            if (models.length > 0) {
              this.forms.ndpbm = parseFloat(models[0].name).toFixed(4);
            } else {
              this.$set(this.forms, "ndpbm", 0)
            }
          }).catch(error => {

            if (error.code == "ECONNABORTED") {
              this.error("Please Check Your Internet Connection");
            }

          });
      } else {
        this.$set(this.forms, "ndpbm", 0)
      }
    },
    asyncJenis() {

      this.fetchJenis = [];
      const baseURI = this.$settings.endPointCeisa + "v1/system-code/index?limit=100&page=1&type=kodeJenisNilai";

      return this.$http
        .get(
          baseURI, { timeout: 100000 }
        )
        .then((response) => {

          var models = response.data.datas.data;

          if (models.length > 0) {
            for (var x = 0; x < models.length; x++) {

              var ob = models[x];
              var md = { code: ob.code, name: ob.name, label: ob.code + " - " + ob.name }
              this.fetchJenis.push(md);

            }
          }
        }).catch(error => {

          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }

        });
    },
    asyncValuta() {

      this.fetchValuta = [];
      const baseURI = this.$settings.endPointCeisa + "v1/system-code/index?limit=1000&page=1&type=kodeValuta";

      return this.$http
        .get(
          baseURI, { timeout: 100000 }
        )
        .then((response) => {

          var models = response.data.datas.data;

          if (models.length > 0) {
            for (var x = 0; x < models.length; x++) {

              var ob = models[x];
              var md = { code: ob.code, name: ob.name, label: ob.code + " - " + ob.name }
              this.fetchValuta.push(md);

            }
          }
        }).catch(error => {

          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }

        });
    },
    asyncHargaBarang() {

      this.fetchHargaBarang = [];
      const baseURI = this.$settings.endPointCeisa + "v1/system-code/index?limit=100&page=1&type=kodeIncoterm";

      return this.$http
        .get(
          baseURI, { timeout: 100000 }
        )
        .then((response) => {

          var models = response.data.datas.data;

          if (models.length > 0) {
            for (var x = 0; x < models.length; x++) {

              var ob = models[x];
              var md = { code: ob.code, name: ob.name, label: ob.code + " - " + ob.name }
              this.fetchHargaBarang.push(md);

            }
          }
        }).catch(error => {

          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }

        });
    },
    asyncAsuransi() {

      this.fetchAsuransi = [];
      const baseURI = this.$settings.endPointCeisa + "v1/system-code/index?limit=100&page=1&type=kodeAsuransi";

      return this.$http
        .get(
          baseURI, { timeout: 100000 }
        )
        .then((response) => {

          var models = response.data.datas.data;

          if (models.length > 0) {
            for (var x = 0; x < models.length; x++) {

              var ob = models[x];
              var md = { code: ob.code, name: ob.name, label: ob.code + " - " + ob.name }
              this.fetchAsuransi.push(md);

            }
          }
        }).catch(error => {

          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }

        });
    },

    forceUpper(e, obj, prop) {
      const start = e.target.selectionStart
      e.target.value = e.target.value.toUpperCase()
      this.$set(obj, prop, e.target.value)
      e.target.setSelectionRange(start, start)
    },
    logout() {

      const baseURI = this.$settings.endPoint + "user/logout";
      this.$http.get(baseURI, { timeout: 10000 }).then((response) => {

        console.log(response);

      });

      this.$logoutUser();
      window.location.href = '/';
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },

    removeField(index, fieldType) {
      fieldType.splice(index, 1);
    },
    reAssignValue() {
      let forms = this.forms;
      if (forms.kodeValuta == null || forms.kodeValuta == "") {
        this.valuta = null;
      } else {
        this.valuta = { code: forms.kodeValuta, name: forms.namaValuta, label: forms.kodeValuta + " - " + forms.namaValuta }
        this.checkKurs(this.valuta);
      }
      if (forms.kodeJenisNilai == null || forms.kodeJenisNilai == "") {
        this.jenisTransaksi = null;
      } else {
        this.jenisTransaksi = { code: forms.kodeJenisNilai, name: forms.namaJenisNilai, label: forms.kodeJenisNilai + " - " + forms.namaJenisNilai }
      }
      if (forms.kodeIncoterm == null || forms.kodeIncoterm == "") {
        this.hargaBarang = null;
      } else {
        this.hargaBarang = { code: forms.kodeIncoterm, name: forms.namaIncoterm, label: forms.kodeIncoterm + " - " + forms.namaIncoterm }
      }
      if (forms.kodeAsuransi == null || forms.kodeAsuransi == "") {
        this.asuransi = null;
      } else {
        this.asuransi = { code: forms.kodeAsuransi, name: forms.namaAsuransi, label: forms.kodeAsuransi + " - " + forms.namaAsuransi }
      }

      this.barang = forms.barang;
    },
  },
  computed: {
    cif: function () {
      var a = 0;
      var kurs = this.forms?.ndpbm ? this.forms?.ndpbm : 0;
      a += parseFloat(this.forms?.nilaiIncoterm ? this.forms?.nilaiIncoterm : 0);
      a += parseFloat(this.forms?.biayaTambahan ? this.forms?.biayaTambahan : 0);
      a += parseFloat(this.forms?.freight ? this.forms?.freight : 0);
      a += parseFloat(this.forms?.asuransi ? this.forms?.asuransi : 0);
      a += parseFloat(this.forms?.vd ? this.forms?.vd : 0);
      a -= parseFloat(this.forms?.biayaPengurang ? this.forms?.biayaPengurang : 0);
      a = parseFloat(a) * kurs;
      return a;
    },
    netto: function () {
      var a = 0;
      let barang = this.forms.barang;
      if (barang && barang.length > 0) {

        barang.forEach(element => {
          a += element?.netto ? element.netto : 0;
        });
      }

      return a;
    },
    vdBarang: function () {
      var a = 0;
      let barang = this.forms.barang;
      if (barang && barang.length > 0) {
        barang.forEach(element => {
          let vds = element.vd;

          if (vds && vds.length > 0) {
            vds.forEach(el => {
              a += el?.nilaiBarangVd ? el.nilaiBarangVd : 0;
            });
          }

        });
      }

      return a;
    },
    nilaiBarangTotal: function () {
      var a = 0;
      let barang = this.forms.barang;
      if (barang && barang.length > 0) {

        barang.forEach(element => {
          a += element?.nilaiBarang ? element.nilaiBarang : 0;
        });
      }

      return a;
    },
  },
  watch: {
    propsData: function (newVal) {
      this.forms = newVal;
      this.reAssignValue();
    },
    forms: function (newVal) {
      this.$emit("formUpdate", newVal);
    },
  },
  created() {
    this.asyncAsuransi();
    this.asyncHargaBarang();
    this.asyncValuta();
    this.asyncJenis();
  },
};
</script>

<style></style>